var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.width,"height":_vm.height,"viewBox":"0 0 24 24","fill":"none"}},[_c('rect',{attrs:{"x":"5.3335","y":"5.33398","width":"13.3333","height":"13.3333","rx":"1.66667","stroke":"currentColor","stroke-width":"1.5"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }